// eslint-disable-next-line no-undef
const BASE_URL = process.env.REACT_APP_API_URL_PDV

const requestOptionsToken = (token) => {
  const head = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      authorization: `Bearer ${token}`,
    },
    mode: 'cors',
  }
  return head
}

const apiPdv = {
  getSales: async () => {
    const token = localStorage.getItem('authToken')
    try {
      const response = await fetch(`${BASE_URL}/sales`, requestOptionsToken(token))

      const data = response.json()

      return data
    } catch (e) {
      return []
    }
  },
  getMethods: async () => {
    const token = localStorage.getItem('authToken')
    const response = await fetch(`${BASE_URL}/methods`, requestOptionsToken(token))
    const data = response.json()
    return data
  },
}

export default apiPdv
